// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"dfeb084a","341":"6e0eebb5","345":"6a5c51b2","356":"49480ff8","385":"c995e1cf","507":"d923b18b","680":"6dc45643","872":"914aa209","904":"42bbbe1d","916":"88ea7fd0","924":"c48f2ac2"}[chunkId] + ".chunk.js";
};